<app-sidebar>
    <div class="container">
        <form class="form" (ngSubmit)="this.handleOrganizationSubmit()"
              [formGroup]="organizationForm">
            <div class="sub-container">
                <h2>{{'dataOrganization' | translate}}</h2>
                <div class="inline-fields">
                    <div class="half-width">
                        <label>{{'nameOfOrganization' | translate}}</label>
                        <mat-form-field class="mat-form-field" appearance="outline">
                            <input formControlName="name" matInput placeholder="{{'nameOfOrganization' | translate}}">
                        </mat-form-field>
                    </div>
                    <div class="half-width">
                        <label>{{'abbreviation' | translate}}</label>
                        <mat-form-field class="mat-form-field" appearance="outline">
                            <input formControlName="shortname" matInput placeholder="{{'abbreviation' | translate}}">
                        </mat-form-field>
                    </div>
                </div>
                <label>{{'address' | translate}}</label>
                <mat-form-field class="full-width" appearance="outline">
                    <input formControlName="address" matInput placeholder="{{'address' | translate}}">
                </mat-form-field>
                <div class="inline-fields">
                    <div class="one-fourth-width">
                        <label>{{'zipCode' | translate}}</label>
                        <mat-form-field class="mat-form-field" appearance="outline">
                            <input formControlName="postcode" matInput placeholder="{{'zipCode' | translate}}">
                        </mat-form-field>
                    </div>
                    <div class="three-fourth-width">
                        <label>{{'city' | translate}}</label>
                        <mat-form-field class="mat-form-field" appearance="outline">
                            <input formControlName="city" matInput placeholder="{{'city' | translate}}">
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="sub-container">
                <h2>{{'contactPerson' | translate}}</h2>
                <div class="inline-fields">
                    <div class="half-width">
                        <label>{{'firstName' | translate}}</label>
                        <mat-form-field class="mat-form-field" appearance="outline">
                            <input formControlName="contactpersonfirstname" matInput placeholder="{{'firstName' | translate}}">
                        </mat-form-field>
                    </div>
                    <div class="half-width">
                        <label>{{'lastName' | translate}}</label>
                        <mat-form-field class="mat-form-field" appearance="outline">
                            <input formControlName="contactpersonfamilyname" matInput placeholder="{{'lastName' | translate}}">
                        </mat-form-field>
                    </div>
                </div>
                <div class="inline-fields">
                    <div class="half-width">
                        <label>{{'phoneNumber' | translate}}</label>
                        <mat-form-field class="mat-form-field" appearance="outline">
                            <input formControlName="phonenumber" matInput placeholder="Placeholder">
                            <mat-icon matPrefix> phone</mat-icon>
                        </mat-form-field>
                    </div>
                    <div class="half-width">
                        <label>{{'email' | translate}}</label>
                        <mat-form-field class="mat-form-field" appearance="outline">
                            <input formControlName="email" matInput placeholder="{{'email' | translate}}">
                            <mat-icon matPrefix>alternate_email</mat-icon>
                        </mat-form-field>
                    </div>
                </div>
                <div class="button-container">
                    <button mat-raised-button color="primary" type="submit" [class.disabled]="organizationForm.invalid" [disabled]="organizationForm.invalid"> {{'submit' | translate}} </button>
                </div>
            </div>
        </form>
    </div>
</app-sidebar>

